<!-- 选择测训 -->
<template>
  <yxt-drawer
    custom-class='yxtbiz_gwnl_custom_drawer'
    :destroy-on-close="true"
    size="1060px"
    :visible.sync="dialogVisible"
    :before-close="beforeDrawClose"
    :title="$t('pc_biz_select_training_label')"
  >
    <div class="yxtbiz-select-training-projects">
      <div class='yxtbiz-select-training-projects-wrap'>
        <div>
          <yxt-popover
            :append-to-body="false"
            popper-class="yxtbiz-exam-arrange-selector__popover"
            placement="bottom-start"
            :visible-arrow="false"
            v-model="showMoreFilter"
          >
            <yxt-button slot="reference" plain class="yxtbiz-filter-btn mr12">
              <yxt-svg
                width="20px"
                height="20px"
                icon-class="filter"
                class="v-top"
              />
              <span class="ml8 v-top">{{
                  $t('pc_biz_common_lbl_moreFilter')
                }}</span>
              <i
                class="ml8"
                :class="
                showMoreFilter ? 'yxt-icon-arrow-up' : 'yxt-icon-arrow-down'
              "
              ></i>
            </yxt-button>
            <yxt-form :inline="true">
              <yxt-row :gutter="20">
                <yxt-col :span="12" class='mb12'>
                  <yxt-form-item
                    label-width="100px"
                    :label="$t('pc_biz_training_lbl_publishdate')/* 测训项目发布时间 */"
                  >
                    <yxt-date-picker
                      v-model="publishDate"
                      format="yyyy-MM-dd"
                      type="daterange"
                      :range-separator="$t('pc_biz_ote_lbl_to')"
                      :start-placeholder="$t('pc_biz_ote_lbl_starttime')"
                      :end-placeholder="$t('pc_biz_ote_lbl_endtime')"
                      @change="search(1)"
                      value-format='yyyy-MM-dd'
                    >
                    </yxt-date-picker>
                  </yxt-form-item>
                </yxt-col>
                <yxt-col :span="12" class='mb12'>
                  <yxt-form-item
                    label-width="100px"
                    :label="$t('pc_biz_training_status')/* 测训项目状态 */"
                  >
                    <yxt-select
                      v-model="statusArray"
                      clearable
                      size="large"
                      :placeholder="$t('pc_biz_ote_lbl_pleaseselect')"
                      @change="search(1)"
                      multiple
                    >
                      <yxt-option
                        v-for="item in statusFilterOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></yxt-option>
                    </yxt-select>
                  </yxt-form-item>
                </yxt-col>
                <yxt-col :span="12" class='mb12'>
                  <yxt-form-item
                    label-width="100px"
                    :label="$t('pc_biz_training_starttime')/* 测训项目开始时间 */"
                  >
                    <yxt-date-picker
                      v-model="startDate"
                      format="yyyy-MM-dd"
                      type="daterange"
                      value-format='yyyy-MM-dd'
                      :range-separator="$t('pc_biz_ote_lbl_to')"
                      :start-placeholder="$t('pc_biz_ote_lbl_starttime')"
                      :end-placeholder="$t('pc_biz_ote_lbl_endtime')"
                      @change="search(1)"
                    >
                    </yxt-date-picker>
                  </yxt-form-item>
                </yxt-col>
                <yxt-col :span="12" class='mb12'>
                  <yxt-form-item
                    label-width="100px"
                    :label="$t('pc_biz_training_source')/* 测训项目来源 */"
                  >
                    <yxt-select
                      v-model="params.source"
                      clearable
                      size="large"
                      :placeholder="$t('pc_biz_ote_lbl_pleaseselect')"
                      @change="search(1)"
                    >
                      <yxt-option
                        v-for="item in sourceOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></yxt-option>
                    </yxt-select>
                  </yxt-form-item>
                </yxt-col>
                <yxt-col :span="12">
                  <yxt-form-item
                    label-width="100px"
                    :label="$t('pc_biz_training_category')/* 测训项目分类 */"
                  >
                    <yxt-select
                      v-model="params.categoryIds"
                      clearable
                      size="large"
                      :placeholder="$t('pc_biz_ote_lbl_pleaseselect')"
                      @change="search(1)"
                      multiple
                    >
                      <yxt-option
                        v-for="item in categoryOptions"
                        :key="item.id"
                        :label="item.categoryName"
                        :value="item.id"
                      ></yxt-option>
                    </yxt-select>
                  </yxt-form-item>
                </yxt-col>
              </yxt-row>
            </yxt-form>
          </yxt-popover>
          <yxt-input
            v-model="params.keyword"
            class="mb16"
            style="width: 240px;"
            :placeholder="$t('pc_biz_gwnl_training_placeholder_inputName')"
            searchable
            @search="search(1)"
          />
        </div>
        <div
          class='yxtbiz-select-training-projects-table'
        >
          <yxt-table
            ref="table"
            v-loading="loading"
            :data="list"
            :row-key="getRowKey"
            height='100%'
            @sort-change="handleSortChange"
            @select-all="selectAll"
            @select="select"
            :default-sort="{ prop: params.orderby, order: params.direction }"
          >
            <yxt-table-column
              type="selection"
              :reserve-selection="true"
              width="55"
            />
            <yxt-table-column
              prop="trainingName"
              min-width="180"
              show-overflow-tooltip
              :label="$t('pc_biz_gwnl_training_lbl_title')"
            >
              <template slot-scope="{row}">
                {{ row.trainingName || '--' }}
              </template>
            </yxt-table-column>
            <yxt-table-column
              :label="$t('pc_biz_training_lbl_classification')"
              prop="categoryName"
              show-overflow-tooltip
              width="120"
            >
            </yxt-table-column>
            <yxt-table-column
              min-width="120px"
              prop="status"
              :label="$t('pc_biz_gwnl_eval_lbl_status')"
              hide-column="disable"
            >
              <template slot-scope="{row}">
                <yxt-tag
                  style="padding: 0;"
                  is-status-tag
                  :type="statusOptions[row.publishStatus].type"
                  size="mini"
                >
                  {{ statusOptions[row.publishStatus].label }}
                </yxt-tag>
              </template>
            </yxt-table-column>
            <yxt-table-column
              prop="publishUser"
              :label="$t('pc_biz_gwnl_lbl_publishperson')"
              show-overflow-tooltip
              width="110"
            >
              <template slot-scope="scope">
                <yxtbiz-user-name :name="scope.row.publishUser || '--'" />
              </template>
            </yxt-table-column>
            <yxt-table-column
              sortable="custom"
              prop="updateTime"
              :label="$t('pc_biz_gwnl_task_publish_time')"
              show-overflow-tooltip
              width="160"
            >
              <template slot-scope="scope">
                <span class="nowrap">{{ scope.row.updateTime }}</span>
              </template>
            </yxt-table-column>
          </yxt-table>
        </div>
        <div class="clearfix mt16 flex">
          <yxt-button
            type="text"
            @click="searchAll"
            :loading='isSearchingAll'
            :disabled='!list.length'
          >
            {{$t('pc_biz_shoptour_all_filter_results' /*全选筛选结果*/)}}
          </yxt-button>
          <div class='col-flex-1'>
            <yxt-pagination
              class="pull-right"
              @current-change="handleCurrentChange"
              :current-page.sync="pager.currentPage"
              :page-size="pager.pageSize"
              layout="total, prev, pager, next"
              :total="pager.total"
            />
          </div>
        </div>
      </div>
      <div class="select-training__result">
        <div class="result-list">
          <div class="result-list__content">
            <yxt-button
              v-if="!selectedList.length"
              class="result-list__select-tip"
              type="text"
              disabled
            >
              {{ $t('pc_comp_select_placeholder') }}...
            </yxt-button>
            <div class='result-list__select-count'>{{$t('pc_biz_kng_lbl_selected')}} {{selectedList.length}} / {{limit}}</div>
            <div style="height: 100%; overflow: hidden;">
              <yxt-scrollbar :fit-height="true">
                <div
                  v-for="item in selectedList"
                  :key="item.id"
                >
                  <yxt-tooltip
                    effect="dark"
                    :content="item.trainingName"
                    placement="top"
                  >
                    <span style='display: inline-block'>
                      <yxt-tag
                        class='select-training__tag mb5 mr5 ellipsis'
                        style='max-width: 160px;'
                        type="info"
                        size="mini"
                        closable
                        @close="handleSelectionClose(item)"
                      >
                        <span class='select-training__taglabel'>{{ item.trainingName }}</span>
                      </yxt-tag>
                    </span>
                  </yxt-tooltip>
                </div>
              </yxt-scrollbar>
            </div>
            <yxt-button
              class="result-list__select-clear"
              type="text"
              :disabled="!selectedList.length"
              @click="clearAllSelection"
            >
              {{ $t('pc_biz_cer_btn_clearall') }}
            </yxt-button>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <yxt-button
        plain
        @click="cancel"
      >
        {{ $t("pc_biz_core_btn_cancel") }}
      </yxt-button>
      <yxt-button
        type="primary"
        @click="handleSelection"
      >
        {{ $t("pc_biz_core_btn_determine") }}
      </yxt-button>
    </div>
  </yxt-drawer>
</template>

<script>
import apiServer from './service';
export default {
  name: 'YxtbizSelectTrainingProjects',
  components: {},
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    defaultValue: Array,
    limit: {
      type: Number,
      default: 1000
    },
    functionCode: {
      type: String,
      default: ''
    },
    dataPermissionCode: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      list: [],
      selectedList: [],
      selectedMap: {},
      params: {
        status: '',
        keyword: '',
        categoryIds: [],
        source: '',
        orderby: 'updateTime',
        direction: 'desc'
      },
      pager: {
        pages: 0,
        pageSize: 50,
        total: 0,
        limit: 0,
        offset: 0,
        currentPage: 1
      },
      statusOptions: [
        {
          label: this.$t('pc_biz_global_unpublished'), // 未发布
          value: 0,
          type: 'failure'
        },
        {
          label: this.$t('pc_biz_global_unpublished'),
          value: 1,
          type: 'failure'
        },
        {
          label: this.$t('pc_biz_global_processing'), // 进行中
          value: 2,
          type: 'success'
        },
        {
          label: this.$t('pc_biz_global_over'), // 已结束
          value: 3,
          type: 'failure'
        }
      ],
      statusArray: [],
      statusFilterOptions: [
        {
          label: this.$t('pc_biz_global_processing'), // 进行中
          value: 2
        },
        {
          label: this.$t('pc_biz_global_over'), // 已结束
          value: 3
        }
      ],
      showMoreFilter: false, // 是否展示更多筛选
      publishDate: [],
      startDate: [], // 开始时间
      source: '', // 来源
      sourceOptions: [
        {
          label: this.$t('pc_biz_training_source0'),
          value: 0
        },
        {
          label: this.$t('pc_biz_training_source1'),
          value: 1
        }
        // {
        //   label: this.$t('pc_biz_training_source2'),
        //   value: 2
        // }
      ],
      categoryOptions: [],
      isSearchingAll: false // 全部筛选结果按钮处理中
    };
  },

  computed: {},

  watch: {
    visible: {
      immediate: true,
      handler: function() {
        this.dialogVisible = this.visible;
        const defaultSelection = JSON.parse(JSON.stringify(this.defaultValue));
        if (this.visible) {
          this.pager.currentPage = 1;
          this.showMoreFilter = false; // 是否展示更多筛选
          this.publishDate = [];
          this.startDate = []; // 开始时间
          this.source = ''; // 来源
          this.selectedMap = {};
          this.params = {
            status: '',
            keyword: '',
            categoryIds: [],
            source: '',
            orderby: 'updateTime',
            direction: 'desc'
          };
          this.statusArray = [];
          this.loading = false;
          this.pager.offset = 0;
          if (defaultSelection) {
            this.selectedList = defaultSelection.map(selection => {
              let obj = {
                id: selection.id,
                trainingName: selection.name
              };
              this.selectedMap[selection.id] = obj;
              return obj;
            });
          } else {
            this.selectedList = [];
          }
          this.search(1);
          this.getCategoryOptions();
        }
      }
    }
  },

  mounted() {
  },

  methods: {
    search(page) {
      if (this.loading) return;
      this.loading = true;
      const data = {
        statusArray: this.statusArray.length ? this.statusArray : [2, 3],
        keyword: this.params.keyword.trim(),
        orderByDate: this.getOrderByDate(),
        orderBy: this.params.orderby,
        source: (this.params.source === 0 || this.params.source === 1) ? this.params.source : -1,
        categoryIds: this.params.categoryIds,
        navCode: this.functionCode,
        dataPermissionCode: this.dataPermissionCode
      };
      const pageParams = {
        limit: this.pager.pageSize,
        offset: page ? (page - 1) * this.pager.pageSize : this.pager.offset
      };
      if (this.publishDate && this.publishDate.length > 1) {
        data.releaseStartTime = this.publishDate[0] + ' 00:00:00';
        data.releaseEndTime = this.publishDate[1] + ' 23:59:59';
      }
      if (this.startDate && this.startDate.length > 1) {
        data.startTime = this.startDate[0] + ' 00:00:00';
        data.endTime = this.startDate[1] + ' 23:59:59';
      }
      apiServer.getTrainingList(data, { params: pageParams }).then((res) => {
        this.list = res.datas;
        this.pager.pages = res.paging.pages;
        this.pager.offset = res.paging.offset;
        this.pager.total = res.paging.count;
        this.loading = false;
        this.$nextTick(() => {
          this.setChecked();
        });
      }).catch(() => {
        this.loading = false;
        this.list = [];
      });
    },
    getOrderByDate() {
      if (this.params.direction === 'desc') {
        return 0;
      }
      if (this.params.direction === 'asc') {
        return 1;
      }
      return undefined;
    },
    getCategoryOptions() {
      apiServer.getTrainingCategory().then((res) => {
        this.categoryOptions = res.datas;
      }).catch(() =>{});
    },
    setChecked() {
      this.$refs.table.clearSelection();
      this.list.forEach(item => {
        if (this.selectedMap.hasOwnProperty(item.id)) {
          this.$refs['table'].toggleRowSelection(item, true);
        } else {
          this.$refs['table'].toggleRowSelection(item, false);
        }
      });
    },
    handleSortChange({ column, prop, order }) {
      this.params.orderby = prop;
      this.params.direction = order;
      this.search(1);
    },
    select(list, row) {
      let isAdd = list.some(v => {
        return v.id === row.id;
      });
      if (!isAdd) {
        delete this.selectedMap[row.id];
      } else {
        if (Object.values(this.selectedMap).length < this.limit || !this.limit) {
          this.selectedMap[row.id] = row;
        } else {
          this.$message.warning(this.$t('pc_biz_training_limit', [this.limit]));
          this.$refs.table.toggleRowSelection(row, false);
        }
      }
      this.selectedList = Object.values(this.selectedMap);
    },
    selectAll(list) {
      let isAdd = list.length !== 0;
      let isOver = this.limit <= Object.values(this.selectedMap).length; // 是否超限
      let isOverBeforeStart = isOver;
      this.list.forEach(item => {
        if (!isAdd) {
          delete this.selectedMap[item.id];
        } else {
          if (isOver || (this.limit && this.limit <= Object.values(this.selectedMap).length)) {
            isOver = true;
            !this.selectedMap[item.id] && this.$refs.table.toggleRowSelection(item, false);
          } else {
            this.selectedMap[item.id] = item;
          }
        }
      });
      if (isOverBeforeStart) {
        this.$message.warning(this.$t('pc_biz_training_limit', [this.limit]));
      } else if (isOver) {
        // 部分选中提示
        this.$message.warning(this.$t('pc_biz_training_limit2', [this.limit]));
      }
      this.selectedList = Object.values(this.selectedMap);
    },
    handleSelectionClose(item) {
      const itemInTable = this.list.find(v => v.id === item.id);
      if (itemInTable) {
        this.$refs.table.toggleRowSelection(itemInTable, false);
      }
      delete this.selectedMap[item.id];
      this.selectedList = Object.values(this.selectedMap);
    },
    clearAllSelection() {
      this.$refs.table.clearSelection();
      this.selectedMap = {};
      this.selectedList = [];
    },
    getRowKey(row) {
      return row.id;
    },
    handleSelection() {
      if (this.selectedList.length > this.limit) {
        this.$message.warning(this.$t('pc_biz_training_limit', [this.limit]));
        return;
      }
      this.$emit('on-selection', this.selectedList.map(i => {
        return {
          name: i.trainingName,
          id: i.id
        };
      }));
      this.$emit('update:visible', false);
    },
    beforeDrawClose(done) {
      this.cancel();
      // this.$emit('update:visible', false);
    },
    cancel() {
      let changed = false;
      if ((this.defaultValue || []).length !== this.selectedList.length) {
        changed = true;
      }
      for (let i = 0; i < this.defaultValue.length; i++) {
        if (!this.selectedList[i]) {
          changed = true;
          break;
        }
        if (this.defaultValue[i].id !== this.selectedList[i].id) {
          changed = true;
          break;
        }
      }
      if (changed) {
        this.$confirm(this.$t('pc_biz_gwnl_save_confirm'), this.$t('pc_common_tit_cancel'), {
          confirmButtonText: this.$t('pc_biz_labelling_confirm'),
          cancelButtonText: this.$t('pc_biz_common_cancel_mini'),
          type: 'warning'
        }).then(() => {
          this.$emit('update:visible', false);
        }).catch(() => {
        });
      } else {
        this.$emit('update:visible', false);
      }
    },
    handleCurrentChange(val) {
      this.pager.currentPage = val;
      this.pager.offset = (this.pager.currentPage - 1) * this.pager.pageSize;
      this.search();
    },
    searchAll() {
      if (this.loading || this.isSearchingAll) return;
      let isOverBeforeStart = this.limit <= Object.values(this.selectedMap).length;
      if (isOverBeforeStart) {
        this.$message.warning(this.$t('pc_biz_training_limit', [this.limit]));
        return;
      }
      this.isSearchingAll = true;
      const data = {
        statusArray: this.statusArray.length ? this.statusArray : [2, 3],
        keyword: this.params.keyword.trim(),
        orderByDate: this.getOrderByDate(),
        orderBy: this.params.orderby,
        source: (this.params.source === 0 || this.params.source === 1) ? this.params.source : -1,
        categoryIds: this.params.categoryIds,
        navCode: this.functionCode,
        dataPermissionCode: this.dataPermissionCode
      };
      const pageParams = {
        limit: 2001, // 后端目前不允许超过2000的限制
        offset: 0
      };
      if (this.publishDate && this.publishDate.length > 1) {
        data.releaseStartTime = this.publishDate[0] + ' 00:00:00';
        data.releaseEndTime = this.publishDate[1] + ' 23:59:59';
      }
      if (this.startDate && this.startDate.length > 1) {
        data.startTime = this.startDate[0] + ' 00:00:00';
        data.endTime = this.startDate[1] + ' 23:59:59';
      }
      apiServer.getTrainingList(data, { params: pageParams }).then((res) => {
        if (res.datas) {
          let isOver = isOverBeforeStart; // 是否超限
          for (let i = 0; i < res.datas.length; i++) {
            const item = res.datas[i];
            if (isOver || (this.limit && this.limit <= Object.values(this.selectedMap).length)) {
              isOver = true;
              break;
            } else {
              this.selectedMap[item.id] = item;
              const tableRow = this.list.find(r => r.id === item.id);
              tableRow && this.$refs.table.toggleRowSelection(tableRow, true);
            }
          }
          if (isOver) {
            // 部分选中提示
            this.$message.warning(this.$t('pc_biz_training_limit2', [this.limit]));
          }
        }
        this.isSearchingAll = false;
        this.selectedList = Object.values(this.selectedMap);
      }).catch(() => {
        this.isSearchingAll = false;
      });
    }
  }
};
</script>

